import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hasInsurance", "insuranceDetails", "uninsuredMessage"]
  static values = {
    hasInsurance: String
  }

  connect() {
    const radioToSelect = this.hasInsuranceTarget.querySelector(`input[value="${this.hasInsuranceValue}"]`)
    if (radioToSelect) {
      radioToSelect.checked = true
    }
    this.toggleInsuranceDetails(false)
  }

  hasInsuranceValueChanged() {
    this.toggleInsuranceDetails(true)
  }

  toggleInsuranceDetails(isStateChange = false) {
    if (this.hasInsuranceValue === 'insured') {
      this.insuranceDetailsTarget.classList.remove('hidden')
      this.uninsuredMessageTarget.classList.add('hidden')
      this.insuranceDetailsTarget.querySelectorAll('input:not([type="file"]), select').forEach(field => {
        field.disabled = false
        field.required = true
      })
      this.insuranceDetailsTarget.querySelectorAll('input[type="file"]').forEach(field => {
        field.disabled = false
        if (!field.dataset.existingFile) {
          field.required = true
        }
      })
    } else {
      this.insuranceDetailsTarget.classList.add('hidden')
      this.uninsuredMessageTarget.classList.remove('hidden')
      this.insuranceDetailsTarget.querySelectorAll('input, select').forEach(field => {
        field.disabled = true
        field.required = false
      })
    }
  }

  updateHasInsurance(event) {
    this.hasInsuranceValue = event.target.value
  }
} 